import React, { useContext } from 'react'
import { GlobalDataContext } from '../../../context/context'
import {  BiPhoneCall } from 'react-icons/bi'
import { BsArrowRight, BsClockHistory } from 'react-icons/bs'
import Navmenu from './NavMenu'
import { Link } from 'react-router-dom'




const HeaderTwo = ({ btnName }) => {

    const { rpdata } = useContext(GlobalDataContext)

    return (
        <header className='z-[10] top-0 w-full absolute'>
            <div className='flex flex-row-reverse md:flex-row '>
                <div className='w-[80%] md:w-[20%] h-auto mt-1'>
                    <img
                        src={rpdata?.dbPrincipal?.logo}
                        alt='logo'
                        loading='lazy'
                        className='w-[90%] md:w-[100%] mx-auto'
                    />
                </div>
                <div className='w-[20%] md:w-[80%] flex md:flex-col flex-row justify-center items-center'>
                    <div className='w-full hidden md:h-[60%] bg-2 md:flex rounded-bl-3xl'>
                        <div className='hidden w-[30%] text-white lg:flex mx-auto items-center justify-center'>
                            <div className='w-[15%] self-center'>
                                <BiPhoneCall fontSize={35} />
                            </div>
                            <div>
                                <a
                                    href={`tel:+1${rpdata?.dbPrincipal?.phones?.[0]?.phone}`}
                                >
                                    <p className='-mb-3'>Phone Number</p>
                                    <h5 className='text-[21px]'>
                                        {rpdata?.dbPrincipal?.phones?.[0]?.phone}
                                    </h5>
                                </a>
                            </div>
                        </div>
                        {/* <div className='hidden w-[30%] text-white lg:flex mx-auto items-center justify-center'>
                            <div className='w-[15%] self-center'>
                                <BiEnvelope fontSize={35} />
                            </div>
                            <div>
                                <a
                                    href={`mailto:${rpdata?.dbPrincipal?.emails?.[0]?.email}`}
                                >
                                    <p className='-mb-3'>E Mail</p>
                                    <span className='text-[21px] font-bold'>
                                        {rpdata?.dbPrincipal?.emails?.[0]?.email}
                                    </span>
                                </a>
                            </div>
                        </div> */}
                        <div className='hidden w-[40%] text-white  lg:flex mx-auto justify-center items-center'>
                            <div className='w-[15%] self-center mr-3'>
                                <BsClockHistory fontSize={35} />
                            </div>
                            <div>
                                <p className='-mb-3'>
                                    {rpdata?.dbPrincipal?.workdays?.[0]?.day}
                                </p>
                                <h5 className='text-[21px]'>
                                    {rpdata?.dbPrincipal?.workHours?.[0]?.hour}
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className='w-full h-[40%] flex items-center py-6'>
                        <nav className='w-full md:w-[80%] px-5 '>
                            <Navmenu />
                        </nav>
                        <div className='w-[20%] hidden md:block'>
                            <Link
                                className='flex justify-center transition ease-in-out delay-200 hover:translate-x-5 duration-300 '
                                to={`/${btnName === 'view all services' ? 'services' : 'contact'}`}
                            >
                                <span className='capitalize text-white text-[18px] font-semibold flex items-center space-x-2 border border-orange-600 border-x-4 border-y-2 px-5 py-2 rounded-lg'>
                                    <p>{btnName ? btnName : 'FREE ESTIMATE'}</p>
                                    <BsArrowRight className='text-2xl font-bold'/>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </header>
    )
}

export default HeaderTwo